import { render, staticRenderFns } from "./InvestCountBoard.vue?vue&type=template&id=f9d12170&scoped=true&"
import script from "./InvestCountBoard.vue?vue&type=script&lang=js&"
export * from "./InvestCountBoard.vue?vue&type=script&lang=js&"
import style0 from "./InvestCountBoard.vue?vue&type=style&index=0&id=f9d12170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d12170",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
